import Cookies from 'universal-cookie';
import { AUTH_TOKEN_COOKIE, getAuthTokenCookieDomain } from 'shared/constants/cookies';

export const updateAuthTokenCookie = (accessCode: string, expiresIn: number) => {
  const cookies = new Cookies();
  const expires = new Date();
  expires.setSeconds(expires.getSeconds() + expiresIn);

  cookies.set(AUTH_TOKEN_COOKIE, accessCode, {
    domain: getAuthTokenCookieDomain(),
    path: '/',
    expires,
    secure: true,
  });
};

export const removeAuthTokenCookie = () => {
  const cookies = new Cookies();

  cookies.remove(AUTH_TOKEN_COOKIE, {
    domain: getAuthTokenCookieDomain(),
    path: '/',
  });
};
